<ul class="profile-list profile-list--phone">
    <li *ngFor="let phone of phones">
        <div class="profile-list-item">{{ getEmailsType(phone.type) | translate }}:</div>
        <div class="profile-list-option text-truncate" title="{{phone.number.phoneNumber}}">{{phone.number.phoneNumber}}
        </div>
    </li>
</ul>